module.exports = __webpack_public_path__ + "static/sui-breadcrumb-divider-d7dba0b31b1a9e8a4f6360d8f8a7c965.png";